import apiReminderMonitor from "../../api";

const extract = (res) => (res.status === "fulfilled" ? res.value?.data?.data ?? [] : []);

// Dropdown data of the Run log filter.
export const loadRunLogFilterDependencies = async () => {
  const [rulesRes] = await Promise.allSettled([apiReminderMonitor.getRuleOptions()]);
  return { rules: extract(rulesRes) };
};
